import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getStatement as fetchStatement } from '../statementsActions';
import {
    getIsStatementLoading,
    getStatementErrorMessage,
    getStatementPdfData
} from '../statementsEntity';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { statementsShape } from '../../../utils/propTypes';
import PdfActions from '../../Actions/PdfActions/PdfActions';
import moment from 'moment';

export class Actions extends Component {
    static propTypes = {
        error: PropTypes.string,
        isStatementLoading: PropTypes.bool,
        onGetStatement: PropTypes.func,
        pdfStatement: PropTypes.string,
        shouldControlAction: PropTypes.bool,
        shouldControlToast: PropTypes.bool,
        statement: statementsShape
    };

    render() {
        const {
            error,
            isStatementLoading,
            onGetStatement,
            pdfStatement,
            shouldControlAction,
            shouldControlToast,
            statement
        } = this.props;

        const date = moment(statement.statementDate).format('YYYY-MM');

        return (
            <PdfActions
                error={error}
                filename={`${statement.merchantId}-${date}`}
                isPdfLoading={isStatementLoading}
                onGetPdf={() => onGetStatement(statement.path, statement.id)}
                pdfData={pdfStatement}
                shouldControlAction={shouldControlAction}
                shouldControlToast={shouldControlToast}
                useIcons
            />
        );
    }
}

function mapStateToProps(state, ownProps) {
    const statement = get(ownProps, 'statement', {});

    return {
        error: getStatementErrorMessage(state, statement.id),
        isStatementLoading: getIsStatementLoading(state, statement.id),
        pdfStatement: getStatementPdfData(state, statement.id)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetStatement: (path, id) => dispatch(fetchStatement(path, id))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Actions);
